import { Configuration, FrontendApi } from "@ory/kratos-client";
import { env } from "src/environment";

const oryEnv = env as typeof env & { ORY_SDK_URL?: string };
const oryBasePath = oryEnv.ORY_SDK_URL || `${oryEnv.API_URL}/auth`;

const oryApi = new FrontendApi(
	new Configuration({
		basePath: oryBasePath,
		baseOptions: {
			withCredentials: true,
		},
	}),
);

export default oryApi;
